// extracted by mini-css-extract-plugin
export default {"googleButton":"Oauth_googleButton__eN1VK","googleIcon":"Oauth_googleIcon__obh1U","content":"Oauth_content__BqQTD"};